import React from "react";
import styled from "styled-components";
import FadeIn from "../atoms/FadeIn";

const borderFromBackground = ({ theme, color = "transparent" }) => {
  const borderColor = {
    white: "white",
    teal: "teal",
    greyLight: "greyAccent",
    greyDientReverse: "greyAccent"
  }[color];

  return `.0625rem solid ${theme.colors[borderColor]}`;
};

const Section = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ padLarge }) => (padLarge ? "10rem 3rem 12rem" : "4rem 3rem")};
  overflow: hidden;
  ${({ vPad }) => (!vPad ? "padding-top: 0; padding-bottom: 0;" : "")};
  background-color: ${({ theme, color }) => theme.colors[color]};
  color: ${({ theme, fontColor }) => theme.colors[fontColor]};
  ${({ height }) => (height ? `height: ${height}vh` : "")};

  border-top: ${borderFromBackground};
  border-bottom: ${borderFromBackground};

  ${props => props.theme.media.mobile`
    padding: ${({ padLarge }) => (padLarge ? "2.5rem 1rem 3rem" : "2rem 1rem")};
    ${({ vPad }) => (!vPad ? "padding-top: 0; padding-bottom: 0;" : "")};
  `};
`;

const SectionContent = styled.div`
  max-width: ${({ narrow }) => (narrow ? "52rem" : "72rem")};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: ${({ justify }) => justify};
  ${({ align }) => `align-items: ${align};`};
`;

export default ({
  children,
  narrow = false,
  height = null,
  padLarge = false,
  color = "transparent",
  fontColor = "dark",
  justify = "flex-start",
  align,
  fixed = false,
  vPad = true,
  hPad = true,
  style = {},
  ...props
}) => {
  return (
    <Section
      style={style}
      vPad={vPad}
      hPad={hPad}
      padLarge={padLarge}
      color={color}
      fontColor={fontColor}
      height={height}
    >
      <SectionContent narrow={narrow} justify={justify} align={align}>
        {!fixed &&
          <FadeIn>
            {children}
          </FadeIn>}
        {fixed && children}
      </SectionContent>
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/components/blocks/Section.js